class Totes{

  getDomain(){
  //test

  //test2

    //Get Shopify Domain Name
    var url;
    url = window.location.href;
    url = /:\/\/([^\/]+)/.exec(url)[1];

    //Remove www if present
    if(url.includes("www.")){
      url = url.replace('www.','');
    }

     switch(url)
        {
            case "acorn.com":
            		return 'acorn';
            break;
            case "acorndtc.myshopify.com":
            		return 'acorn';
            break;
            case "acorndtcdev.myshopify.com":
            		return 'acorn';
            break;
            case "totes.com":
            		return 'totes';
            break;
             case "totesdtc.myshopify.com":
            		return 'totes';
            break;
             case "totesdtcdev.myshopify.com":
            		return 'totes';
            break;
             case "isotoner.com":
            		return 'isotoner';
            break;
            case "isotoner.myshopify.com":
            		return 'isotoner';
            break;
            case "isotonerdev.myshopify.com":
            		return 'isotoner';
            break;
             case "totes-isotoner.ca":
                    return 'totesisotoner-ca';
            break;
            case "totesisotoner.myshopify.com":
            		 return 'totesisotoner-ca';
            break;
            case "totesisotonerdev.myshopify.com":
            		 return 'totesisotoner-ca';
            break;
            default:
                void(0);
        }
  }
}//End Class Totes

//Supports Delay to allow for third party elements to load.
var delay = (function(){
    var timer = 0;
    return function(callback, ms){
        clearTimeout (timer);
        timer = setTimeout(callback, ms);
    };
})();

$(window).on('load', function() {
    //US3125: TA14005 ADA360 Issue #85 2.0
    (function () {
        //US3125: TA14005 ADA360 Issue #85 2.0
        if($('span').hasClass('current_price')){
            $('span.current_price').each(function() {
                if ($(this).children('.money').length) {
                    $( ".current_price" ).prepend( "<span class='sr-only' style='position: absolute; left: -99999999px'>Current price: " + $(this).text() + "</span>" );
                }
            });
        };
        //US3125: TA14005 ADA360 Issue #85 2.0
        if($('span').hasClass('was-price')){
            $('span.was-price').each(function() {
                if ($(this).children('.money').length) {
                    $( ".current_price" ).prepend( "<span class='sr-only' style='position: absolute; left: -99999999px'>Original price: " + $(this).text() + "</span>" );
                }
            });
        };
        //US3125: TA14005 ADA360 Issue #85 2.0
        //mini cart
        // .ajax-cart__price price
        if($('div').hasClass('ajax-cart__price')){
            $('div.ajax-cart__price').each(function() {
                if ($(this).children('.money').length) {
                    $( ".ajax-cart__price" ).prepend( "<span class='sr-only' style='position: absolute; left: -99999999px'>Item price: " + $(this).text() + "</span>" );
                    return false;
                }
            });
        };
        //US3125: TA14005 ADA360 Issue #85 2.0
        //mini cart  Discounted Price
        // .ajax-cart__discount
        if($('p').hasClass('ajax-cart__discount')){
            $('p.ajax-cart__discount').each(function() {
                if ($(this).children('.money').length) {
                    $( ".ajax-cart__discount" ).prepend( "<span class='sr-only' style='position: absolute; left: -99999999px'>Discounted Price: " + $(this).text() + "</span>" );
                    return false;
                }
            });
        };
    })();
});
$(window).on('load', function() {
    (function () {
        //ADA US3108:TA13977
        //Classess: .vprice, .wprice, .vcaprice, .ifprice, .ioprice, .ssprice
        //I added pprice, cprice
        if ($('span').hasClass('vprice')) {
            assignPriceIds('vprice');
        }
        if ($('span').hasClass('wprice')) {
            assignPriceIds('wprice');
        }
        if ($('span').hasClass('vcaprice')) {
            assignPriceIds('vcaprice');
        }
        if ($('span').hasClass('ifprice')) {
            assignPriceIds('ifprice');
        }
        if ($('span').hasClass('ioprice')) {
            assignPriceIds('ioprice');
        }
        if ($('span').hasClass('ssprice')) {
            assignPriceIds('ssprice');
        }
    })();
});

function assignPriceIds(ptype){
    //ADA US3108:TA13977
    //Assigns Price ids to div containing prices
    let pt = document.getElementsByClassName(ptype);
    for (let i = 0; i < pt.length; i++){
        let xpt = pt[i];
        xpt.setAttribute("id", ptype + "-" + i);
        addSrText(ptype, ptype + "-" + i);
    }
}

function addSrText(ptype, ptypeId){
    //ADA US3108:TA13977
    //Classess: .vprice, .wprice, .vcaprice, .ifprice, .ioprice, .ssprice, .ctprice
    let stsru = document.getElementById(ptypeId);
    let span = document.createElement('span');
    let awp = document.getElementById(ptypeId).innerText.trim();
    switch(ptype) {
        case 'cprice':
            //.cprice = current_price
            span.innerHTML = 'Current Price: ' + awp;
            span.className = 'cprice';
            break;
        case 'vprice':
            //.vprice = variant.price
            span.innerHTML = 'Current Price: ' + awp;
            span.className = 'vprice';
            break;
        case 'wprice':
            //.wprice = was-price
            span.innerHTML = 'Original Price: ' + awp;
            span.className = 'wprice';
            break;
        case 'vcaprice':
            //.vcaprice = variant.compare_at_price
            //Defined: Within the Admin Product Section; To show a reduced price, move the variant's original price into Compare at price. Enter a lower value into Price
            span.innerHTML = 'Reduced Price: ' + awp;
            span.className = 'vacprice';
            break;
        case 'ifprice':
            //.ifprice = item.final_price
            span.innerHTML = 'Price: ' + awp;
            span.className = 'ifprice';
            break;
        case 'ioprice':
            //.ioprice = item.original_price
            span.innerHTML = 'Original Price: ' + awp;
            span.className = 'ioprice';
            break;
        case 'ssprice-Hold':
            //DWS-Bug this is causing a problem with issue 22
            //.ssprice = .sale .savings
            // span.innerHTML = ' Sale Price: ' + awp;
            //  span.className = 'ssprice';
            break;
        case 'ctprice':
            //.ctprice = Cart Subtotal
            span.innerHTML = ' Subtotal: ' + awp;
            span.className = 'ctprice';
            break;
        default:
            //.otprice = other price 'non-descriptive price'
            span.innerHTML = 'Other price: ' + awp;
            span.className = 'otprice';
    }
    span.className = 'sr-only is-hidden';
    stsru.parentNode.insertBefore(span, stsru);
}

 function adaSizeChart(){
    //US3032->TA13773
    $( ".product__size-chart" ).click(function() {
     delay(function(){
        ($(".fancybox-container")).attr({"aria-modal": "true", "aria-label": "Size Guide"});
    },1000 );
    });
}

function adaRemoveUnwantedTabindex(){
   //ADA360 US3032 -> TA13767
   $("div.product-gallery__main,div.product-gallery__thumbnails").removeAttr("tabindex");

    //ADA360->US3120:TA13988
    if($('a').hasClass('sl-icon')){
        $('.sl-icon').each(function(){
            let socialMediaBrand = $(this).attr('title');
            $(this).attr('aria-label', socialMediaBrand).removeAttr("tabindex").removeAttr( "role" );
        });
    }
    //ADA360->US3120:TA13988
    if($('span').hasClass('icon')){
        $('svg').each(function(){
            $(this).removeAttr("tabindex");
        })
    }

    //ADA360 US3143->TA14074 #93
    $("div.rebuy-product-grid").removeAttr("tabindex");
}

function cookieConsentDialogBox(){
  //US3032
  $( "#cookie-consent-dialogBox" ).wrap(function() {
            return "<span aria-hidden='true'></span>";
        });
}

function facebookVerification(){
      /* HDT: 20765, 20764, 20763 */
       const domain = new Totes();
       let url = domain.getDomain();

      if(url == 'acorn'){
            $('<meta name="facebook-domain-verification" content="umwy2lxjr53iqwul7nay0bub8hmesh"/>').insertAfter( $('meta').first());
       }else if(url == 'isotoner'){
            $('<meta name="facebook-domain-verification" content="tnx082fru9rk4kfy1c3eftp8r4wi0v"/>').insertAfter( $('meta').first());
       }else if(url == 'totes'){
            $('<meta name="facebook-domain-verification" content="oym7u7nmx5u55jpb7svh4oeyy8kk7k"/>').insertAfter( $('meta').first());
       }else{
       //do nothing
      }
    }

function trustedSites(){
//US2981
        const domain = new Totes();

        if(domain.getDomain() == 'acorn'){
            //Add TrustedSites to Minicart
            $('<!--TrustedSite Code--><div class="trustedsite-trustmark" style="margin: 5px 0 " data-type="213" data-width="135"  data-height="56"></div><!--TrustedSite Code-->' ).insertAfter( ".ajax-cart__cart-link" );
            //Footer
            $( '<!--TrustedSite Code--><div class="trustedsite-trustmark" style="margin: 5px 0 " data-type="213" data-width="150"  data-height="56"></div><!--TrustedSite Code-->' ).insertAfter( "#chtmlph" );
            //Checkout under "Return to cart" hyperlink
            //script moved to checkout.liquid
            //Checkout under "order-summary_"
            //script moved to checkout.liquid
            }else if(domain.getDomain() == 'isotoner'){
            //Add TrustedSites to Minicart
            $('<!--TrustedSite Code--><div class="trustedsite-trustmark" style="margin: 5px 0 " data-type="213" data-width="135"  data-height="56"></div><!--TrustedSite Code-->' ).insertAfter( ".ajax-cart__cart-link" );
            //Footer
            $( '<!--TrustedSite Code--><div class="trustedsite-trustmark" style="margin: 5px 0 " data-type="213" data-width="150"  data-height="56"></div><!--TrustedSite Code-->' ).insertAfter( "#chtmlph" );
            //Checkout under "Return to cart" hyperlink
            //script moved to checkout.liquid
            //Checkout under "order-summary_"
            //script moved to checkout.liquid
        }else if (domain.getDomain() == 'totes') {
            //Add TrustedSites to Minicart
            $('<!--TrustedSite Code--><div class="trustedsite-trustmark" style="margin: 5px 0 " data-type="213" data-width="135"  data-height="56"></div><!--TrustedSite Code-->' ).insertAfter( ".ajax-cart__cart-link" );
            //Footer
            $( '<!--TrustedSite Code--><div class="trustedsite-trustmark" style="margin: 5px 0 " data-type="213" data-width="150"  data-height="56"></div><!--TrustedSite Code-->' ).insertAfter( "#chtmlph" );
            //Checkout under "Return to cart" hyperlink
            //script moved to checkout.liquid
            //Checkout under "order-summary_"
            //script moved to checkout.liquid
        }else if (domain.getDomain() == 'totesisotoner-ca') {
            //Add TrustedSites to Minicart
            $('<!--TrustedSite Code--><div class="trustedsite-trustmark" style="margin: 5px 0 " data-type="213" data-width="135"  data-height="56"></div><!--TrustedSite Code-->' ).insertAfter( ".ajax-cart__cart-link" );
            //Footer
            $( '<!--TrustedSite Code--><div class="trustedsite-trustmark" style="margin: 0 " data-type="213" data-width="150"  data-height="56"></div><!--TrustedSite Code-->' ).insertAfter( "#chtmlph" );
            //Checkout under "Return to cart" hyperlink
            //script moved to checkout.liquid
            //Checkout under "order-summary_"
            //script moved to checkout.liquid
        }else{
            //do nothing.
        }
    }

    (function () {
       //US3108:TA13977
       let pn = window.location.pathname;
        pn = pn.split("/").pop();
       if(pn ==="search"){
           document.getElementById("searchFor").removeAttribute("aria-expanded");
       }
       $('a.header__link').hover(
        function () {
            //ADA Fix --> aria-expanded = false | true
            //determine if div.is-active true
            let axh = $(this).hasClass("is-active");
            if(axh){
                $(this).attr("aria-expanded","true");
            }else{
                $(this).attr("aria-expanded","false");
            }
        });
       $('a.search-content').click(function(){
         let axs = document.getElementById("searchFor").getAttribute("aria-expanded");
         if(axs != undefined) {
           if (axs == "true") {
             axs = "false"
           } else {
             axs = "true"
           }
           document.getElementById("searchFor").setAttribute("aria-expanded", axs);
         }
       });
       $('button.search-overlay__close').click(function(){
         let bxs = document.getElementById("searchFor").getAttribute("aria-expanded");
         if(bxs != undefined) {
           if (bxs == "true") {
             bxs = "false"
           } else {
             bxs = "true"
           }
           document.getElementById("searchFor").setAttribute("aria-expanded", bxs);
         }
       });
      })();

    (function () {
    //US2982
        var cname ="priorityText";
        var myNodelist;
        myNodelist = document.querySelectorAll("[data-navlink-handle='sale'],[data-navlink-handle='clearance']");
        var i;
        for (i = 0; i < myNodelist.length; i++) {
              myNodelist[i].className.innterText = "priorityText";
              var ckText = myNodelist[i].innerText.trim().toLowerCase();
            if(ckText == "sale" || ckText == "clearance"){
                    myNodelist[i].className = myNodelist[i].className + " " + cname;
                }
        }
    })();
    $(window).on('load', function() {
        (function () {
             //ADA360
             var tooltipClass = document.getElementsByClassName("tooltip");
             if(typeof(tooltipClass) != 'undefined' && tooltipClass != null){
                 var ttcl = document.getElementsByClassName('tooltip');
                 for (var i = 0; i < ttcl.length; i++) {
                     ttcl[i].setAttribute("role", "tooltip");
                 }
             }
             var tooltipClassTwo = document.getElementsByClassName("tooltip2");
             if(typeof(tooltipClassTwo) != 'undefined' && tooltipClassTwo != null){
                 var ttcl2 = document.getElementsByClassName('tooltip2');
                 for (var i = 0; i < ttcl2.length; i++) {
                     ttcl2[i].setAttribute("role", "tooltip");
                 }
             }
             //ADA360 #144
             var tooltipControl = document.getElementsByClassName("tooltip-control");
             if(typeof(tooltipControl) != 'undefined' && tooltipControl != null){
                 var ttc = document.getElementsByClassName('tooltip-control');
                 for (var i = 0; i < ttc.length; i++) {
                     ttc[i].setAttribute("role", "tooltip");
                 }
             }
            //ADA360 #18
            var elts = document.getElementsByClassName("is-hidden");
            if(typeof(elts) != 'undefined' && elts != null){
                for(var e = 0; e < elts.length; e++) {
                    var elt = elts[e];
                    elt.removeAttribute("aria-hidden");
                }
            }
            //ADA No Apparent ADA360 Call out
            var bvReviewCt = document.getElementsByClassName("bv_text");
            if(typeof(bvReviewCt) != 'undefined' && bvReviewCt != null){
                var bvt = document.getElementsByClassName('bv_text');
                for (let i = 0; i < bvt.length; i++) {
                    let elm = bvt[i].innerHTML;
                    let span = document.createElement('span');
                    span.innerHTML = 'Rating: ' + elm;
                    span.className = 'bv_text';
                    span.className = 'sr-only is-hidden';
                    bvt[i].insertBefore(span, bvt[i].firstChild);
                }
            }
            //ADA360 #37
            $('.flickity-slider>div').each(function(i, obj) {
                $(this).attr("role", "button").attr("tabindex", "0");
            });
            //#147
            $('.flickity-slider>div').click(function () {
                $('.flickity-slider>div').each(function(i, obj) {
                    var attr = $(this).attr('aria-current');
                    if (typeof attr !== typeof undefined && attr !== false) {
                        $(this).removeAttr( "aria-current" );
                    }
                });
                $(this).attr("aria-current", "true");
            });
            $("noscript").each(function() {
                //ADA360 #69
                let elm = $(this);
                elm.attr("tabindex", "-1");
            });
            //US3143 TA14078: #36
            $("div.product-gallery__image").removeAttr("tabindex");
            $("div.product-gallery__thumbnail").removeAttr("tabindex");
            //US3143 TA14080 #92
            $("div.slider-gallery").removeAttr("tabindex");
        })();
    });

    //Set Delay
    delay(function(){
        adaSizeChart();
       adaRemoveUnwantedTabindex();
       cookieConsentDialogBox();
       trustedSites();
       facebookVerification();
    }, 4000 ); // end delay
